<template>
    <div class="comContent">
        <div class="flex-list">
            <div class="title">
                活动名称： {{ activityName }}
            </div>
            <div class="btn-box">
                <el-button size="small" type="plain" @click="goBack()">返回</el-button>
                <el-button size="small" type="plain" @click="reject()" v-if="auditStatus == 0">驳回</el-button>
                <el-button size="small" type="primary" @click="pass()" v-if="auditStatus == 0">通过</el-button>
            </div>
        </div>
        <div style="margin-top: 10px;">
            <el-row>
                <el-col>
                    店铺信息
                </el-col>
            </el-row>

            <el-row style="margin-top: 10px;">
                <el-col :span="24">
                    <el-descriptions title="" direction="horizontal" :column="3" border>
                        <el-descriptions-item label="商户名称">{{ formIn.shopName }}</el-descriptions-item>
                        <el-descriptions-item label="在售商品">{{ formIn.onSale }}</el-descriptions-item>
                        <el-descriptions-item label="近30日完结订单量"> {{ formIn.finishedOrderSum }} </el-descriptions-item>

                        <el-descriptions-item label="保证金余额">{{ formIn.useAmount | filtersMoney}}</el-descriptions-item>
                        <el-descriptions-item label="商家下架商品">{{ formIn.shopSold }}</el-descriptions-item>
                        <el-descriptions-item label="近30日售后订单量">{{ formIn.afterSaleOrderSum }} </el-descriptions-item>

                        <el-descriptions-item label="保证金占用余额">{{ formIn.shopSecurityDeposit |filtersMoney}} </el-descriptions-item>
                        <el-descriptions-item label="上架待审核商品">{{ formIn.putawayAwaitCheck }}</el-descriptions-item>
                        <el-descriptions-item label="近30日完结订单金额">{{ formIn.finishedOrderMoney | filtersMoney}}</el-descriptions-item>


                        <el-descriptions-item label="  "></el-descriptions-item>
                        <el-descriptions-item label="  "></el-descriptions-item>
                        <el-descriptions-item label="近30日售后订单金额">{{ formIn.afterSaleOrderMoney | filtersMoney}}</el-descriptions-item>

                    </el-descriptions>
                </el-col>

            </el-row>
        </div>

        <div style="margin-top: 10px;">
            <myTable :index="index" :selection="false" :page="page" :showpage="true" :operation="false" v-loading="loading"
                :table-data="tableData" :table-option.sync="tableOption" @page-change="getInfo" :expand="false">
                <template slot="goodsInfo" slot-scope="scope">
                    <div class="imgBox">
                        <div class="">
                            <img :src="scope.row.image || avater" alt="" style="width: 80px;height:80px">
                        </div>
                        <div style="margin-left:20px" class="fontBox">
                            <span class="spanFont name">{{ scope.row.name }}</span> 
                            <!-- <span class="spanFont">{{ scope.row.approvalNumber }}</span> -->
                            <span class="spanFont">{{ scope.row.specification }}</span>
                            <span class="spanFont ">{{ scope.row.factory }}</span>
                            <span class="spanFont ">近30日销售金额：{{ scope.row.marketAmount | filtersMoney}}</span>
                            
                        </div>
                    </div>
                </template>
            </myTable>
        </div>

        <el-dialog :title="'审核'" :visible.sync="visible" :lock-scroll="true" width="500px" :before-close="handleClose"
            append-to-body>
            <section class="remarks">
                <div class="r-title">
                    正在驳回商户名称参加活动名称的申请，请输入驳回原因
                </div>
                <el-input v-model.trim="formIn.checkReason" type="textarea" :row="4" style="width: 100%" maxlength="200"
                    show-limit-word></el-input>
            </section>
            <div class="btnBox">
                <el-button size="small" @click="handleClose">取消</el-button>
                <el-button type="primary" size="small" @click="submitReject">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import avater from "/public/img/default.png"

const activeOptions = [
    {
        name: "待开始",
        id: 1,
    },
    {
        name: "进行中",
        id: 2,
    },
    {
        name: "已结束",
        id: 3,
    },
    {
        name: "已停止",
        id: 4,
    },
    {
        name: "草稿中",
        id: 5,
    },
];
import searchForm from "./component/searchForm.vue";
import myTable from "@/components/myTable";
import { queryActivityApplyInfo, checkActivityApply } from "@/api/platActivityManage";

export default {
    components: { searchForm, myTable },
    props: {},
    data() {
        return {
            auditStatus:null,
            avater: avater,
            activityName: '',
            visible: false,
            expanded: false,
            isExpanded: false,
            loading: false,
            operation: true,
            selection: true,
            index: false,
            page: {
                total: 0,
                current: 1,
                size: 10,
                pageSizes: [10, 20, 30, 50],
            },
            tableData: [],
            tableOption: [
                { label: "商品信息", prop: "goodsInfo", slot: true },
                { label: "批准文号", prop: "approvalNumber", },
                { label: "活动价", prop: "price",type:'money' },
                { label: "活动库存", prop: "inventory", },

            ],
            searchData: {
            },
            expandedList: [

            ],
            searchLabelList: [
                {
                    name: "搜索活动名称",
                    fieldName: "payShopName",
                    type: "input",
                },
                {
                    name: "搜索店铺",
                    fieldName: "goodsName",
                    type: "input",
                },
                {
                    name: "筛选状态",
                    width: 150,
                    fieldName: "status",
                    type: "select",
                    disabled: false,
                    select: activeOptions,
                },
                {
                    name: "筛选申请时间",
                    fieldName: "date",
                    type: "date",
                },
            ],
            formIn: {
                checkReason: ''
            }
        };
    },
    filters: {
        filtersStatus(e) {
            for (let i = 0; i < activeOptions.length; i++) {
                if (e == activeOptions[i].id) {
                    return activeOptions[i].name
                }
            }
        },
        filtersMoney(e){
            if(e){
                return '￥'+ parseFloat(e).toFixed(2)
            }else{
             return '￥'+'0.00'
            }
        }
    },
    created() { },
    mounted() {
        this.searchData.shopId = this.$route.query.shopId;
        this.searchData.applyId = this.$route.query.applyId;
        this.auditStatus = this.$route.query.status;
        console.log(this.$route.query.status, '--this.$route.query.status')
        console.log(this.formIn.status==0, '--this.formIn.status')
        this.activityName = this.$route.query.activityName;
        this.getInfo();
    },
    methods: {

        handleClose() {
            this.visible = false;
        },
        reject() {
            this.visible = true;
        },
        pass() {
            // this.visible = true;
            this.$confirm('此操作将商品审核状态设置为通过, 是否确认操作?', '提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
            }).then(() => {
                let params = {};
                params.applyId = this.searchData.applyId;
                params.status = 2; //审核状态：1-驳回，2-通过
                params.checkReason = '';
                checkActivityApply(params).then((res) => {
                    if (res) {
                        this.$message.success('操作成功！')
                        this.visible = false;
                        this.$router.back(-1)

                    }
                }).catch((err) => {

                })
            }).catch(() => {
                this.$message.warning('您已取消操作');
            });
        },

        submitReject() {
            let params = {};
            params.applyId = this.searchData.applyId;
            params.status = 1; //审核状态：1-驳回，2-通过
            params.checkReason = this.formIn.checkReason;
            checkActivityApply(params).then((res) => {
                if (res) {
                    this.$message.success('操作成功！')
                    this.visible = false;
                    this.$router.back(-1)

                }
            }).catch((err) => {

            })
        },

        getInfo(current) {
            const params = Object.assign({}, this.searchData);
            params.size = this.page.size;
            if (current) {
                params.current = 1;
            } else {
                params.current = this.page.current;
            }
            queryActivityApplyInfo(params).then((res) => {
                if (res) {
                    this.tableData = res.page.records;
                    this.page.total = res.page.total;
                    this.formIn = res;
                } else {
                    this.tableData = [];
                    this.page.total = 0;
                }
            });
        },
        resetForm() {
            this.page.current = 1;
            for (const key in this.searchData) {
                this.searchData[key] = ""
            }

        },
        // 查看详情
        checkDetails(row, type) {
            if (type == 'create') {
                this.$router.push({
                    path: './platActivityManage-createActivity',
                    query: { id: row.id, orderId: row.orderId }
                })
            }
        },
        handleExpand() {
            this.expanded = !this.expanded;
        },
        goBack() {
            this.$router.back(-1)
        },

    },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
    height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
    height: calc(100% - 118px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
    height: calc(100% - 78px) !important;
    overflow-y: scroll !important;
}

.expand-form {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}

.flex-box {
    display: flex;
    justify-content: space-between;
}

.remarks {
    margin-bottom: 10px;
}

.r-title {
    font-size: 12px;
    margin-bottom: 10px;
}

.flex-list {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .title {
        font-weight: bold;
    }
}
.spanFont {
display: block;
}
.imgBox {
    
    display: flex;
    justify-content: flex-start;
}
</style>
  